import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu } from "antd";
import {
  RiShieldUserFill,
  RiDashboardLine,
  RiGitBranchLine,
  RiKey2Line,
  RiUserLine,
  RiTeamLine,
  RiToolsFill,
} from "react-icons/ri";
import { HiUserGroup } from "react-icons/hi";
import { FaUniversity } from "react-icons/fa";
import {
  MdOutlineDynamicForm,
  MdOutlineSplitscreen,
  MdOutlineScreenShare,
  MdOutlineLocationOn,
} from "react-icons/md";
import { TbMapPinCode } from "react-icons/tb";
import data from "./NavItems.json";

// Computed once at module load — not recreated on every render.
const ICONS = {
  RiDashboardLine: <RiDashboardLine />,
  RiShieldUserFill: <RiShieldUserFill />,
  RiGitBranchLine: <RiGitBranchLine />,
  HiUserGroup: <HiUserGroup />,
  FaUniversity: <FaUniversity />,
  MdOutlineDynamicForm: <MdOutlineDynamicForm />,
  MdOutlineSplitscreen: <MdOutlineSplitscreen />,
  MdOutlineScreenShare: <MdOutlineScreenShare />,
  MdOutlineLocationOn: <MdOutlineLocationOn />,
  TbMapPinCode: <TbMapPinCode />,
  RiKey2Line: <RiKey2Line />,
  RiUserLine: <RiUserLine />,
  RiTeamLine: <RiTeamLine />,
  RiToolsFill: <RiToolsFill />,
};

/**
 * Pure recursive function — builds the authorised menu without mutating source data.
 * A parent item is included only when the user holds at least one of its auth permissions.
 * A leaf item is included only when the user holds its exact auth permission.
 */
function buildAuthorisedMenu(items, permissions) {
  return items.reduce((acc, item) => {
    if (item.children) {
      if (permissions.some((p) => item.auth.includes(p))) {
        acc.push({
          label: item.label,
          key: item.key,
          icon: ICONS[item.image],
          children: buildAuthorisedMenu(item.children, permissions),
        });
      }
    } else if (permissions.includes(item.auth)) {
      acc.push({
        label: item.label,
        key: item.key,
        icon: ICONS[item.image],
      });
    }
    return acc;
  }, []);
}

const NavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // Initialise directly — avoids the render-time setState anti-pattern.
  const [current, setCurrent] = useState(location.pathname.substring(1));
  const permissions = useSelector((state) => state.auth.permissions ?? []);

  const menuItems = buildAuthorisedMenu(data, permissions);

  const onClick = ({ key }) => {
    navigate(`/${key}`);
    setCurrent(key);
  };

  return (
    <Menu
      mode="horizontal"
      items={menuItems}
      onClick={onClick}
      selectedKeys={[current]}
    />
  );
};

export default NavBar;
